import React, { useContext } from 'react';
import AppEmojiIcons from '../../icons/emojiIcons';
import { AdminContext } from '../../context/AdminContext';
import AppIcons from '../../icons';
import styles from './styles.module.css';

export default function SelectedNavbar({
  selectedMessage,
  setSelectedMessage,
  onClickDownload,
  onClickReply,
  onClickForward,
  onClickDelete,
  setShowSelectBox,
  downloadedFiles,
  onClickLocation,
  path,
  onClickCopy,
  onClickFav,
}) {
  const { isElectron } = useContext(AdminContext);
  console.log('selectedMessage', selectedMessage, isElectron);
  return (
    <div className={`${styles.container} mainBg`}>
      <p>{selectedMessage?.length}</p>
      {selectedMessage?.length == 1 &&
        selectedMessage?.[0]?.typeId != 3 &&
        selectedMessage?.[0]?.typeId != 4 &&
        selectedMessage?.[0]?.typeId != 1 && (
          <>
            {downloadedFiles?.findIndex(
              (x) => x == selectedMessage?.[0]?.file?.name
            ) == -1 ? (
              <>
                {isElectron ? (
                  <AppIcons.DownloadIcon
                    fill={`#fff`}
                    width={20}
                    height={20}
                    onClick={onClickDownload}
                    className={`cursor-pointer`}
                  />
                ) : (
                  <a
                    href={`${path}${selectedMessage?.[0]?.file?.name}`}
                    download
                    target="_blank"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    className={`${styles.downloadIcon} noFilterSvg mainBg flex flex-row justify-center items-center`}
                  >
                    <AppIcons.DownloadIcon
                      width={20}
                      height={20}
                      // className={`${styles.downloadIcon} noFilterSvg mainBg`}
                      // onClick={() => {
                      //   downloadFunction(
                      //     `${path}${item?.file?.name}`,
                      //     `${item?.file?.name}`,
                      //     item?.file?.fileExtension?.type
                      //   );
                      // }}
                    />
                  </a>
                )}
              </>
            ) : (
              <>
                {isElectron && (
                  <AppIcons.LocationIcon
                    className={`${styles.locationIcon} noFilterSvg mainBg cursor-pointer`}
                    width={20}
                    height={20}
                    onClick={() => onClickLocation()}
                  />
                )}
              </>
            )}
          </>
        )}
      {selectedMessage?.length == 1 &&
        (selectedMessage?.[0]?.typeId == 4 ||
          selectedMessage?.[0]?.typeId == 1) && (
          <AppIcons.copyIcon
            fill={`#fff`}
            width={20}
            height={20}
            onClick={onClickCopy}
            className={`cursor-pointer`}
          />
        )}
      {selectedMessage?.length == 1 && (
        <>
          <AppIcons.replyForwardIcon
            fill={`#fff`}
            width={20}
            height={20}
            onClick={onClickReply}
            className={`cursor-pointer `}
          />
          {selectedMessage?.[0]?.chatPin?.length != 0 &&
          selectedMessage?.[0]?.chatPin != undefined ? (
            <AppEmojiIcons.StarFullIcon
              onClick={() => onClickFav()}
              width={'20px'}
              height={'20px'}
              fill={`#fff`}
              className={`cursor-pointer`}
            />
          ) : (
            <AppEmojiIcons.StarIcon
              onClick={() => onClickFav()}
              width={'20px'}
              height={'20px'}
              fill={`#fff`}
              className={`cursor-pointer`}
            />
          )}
        </>
      )}
      {selectedMessage?.length && (
        <AppIcons.replyIcon
          fill={`#fff`}
          width={20}
          height={20}
          onClick={onClickForward}
          className={`cursor-pointer ${styles.forwardIcon}`}
        />
      )}
      <AppIcons.deleteIcon
        fill={`#fff`}
        width={20}
        height={20}
        onClick={() => {
          onClickDelete();
          setSelectedMessage([]);
          setShowSelectBox();
        }}
        className={`cursor-pointer`}
      />
    </div>
  );
}
